var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifiActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5899 12.5904C19.4299 12.5904 19.2699 12.5404 19.1299 12.4304C15.0999 9.32039 9.88993 9.32039 5.85993 12.4304C5.52993 12.6804 5.05993 12.6204 4.80993 12.3004C4.55993 11.9704 4.61993 11.5004 4.93993 11.2504C9.52993 7.70039 15.4599 7.70039 20.0399 11.2504C20.3699 11.5004 20.4299 11.9704 20.1699 12.3004C20.0399 12.4904 19.8199 12.5904 19.5899 12.5904Z",
    fill: "url(#paint0_linear_1721_53238)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9.11039C22.34 9.11039 22.18 9.06039 22.04 8.95039C16.24 4.47039 8.75001 4.47039 2.96001 8.95039C2.63001 9.20039 2.16001 9.14039 1.91001 8.82039C1.65001 8.50039 1.71001 8.02039 2.04001 7.77039C8.39001 2.86039 16.6 2.86039 22.96 7.77039C23.29 8.02039 23.35 8.49039 23.09 8.82039C22.95 9.01039 22.72 9.11039 22.5 9.11039Z",
    fill: "url(#paint1_linear_1721_53238)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7096 16.2403C17.5496 16.2403 17.3896 16.1903 17.2496 16.0803C14.3696 13.8503 10.6396 13.8503 7.74958 16.0803C7.41958 16.3303 6.94958 16.2703 6.69958 15.9503C6.44958 15.6203 6.50958 15.1503 6.82958 14.9003C10.2696 12.2403 14.7196 12.2403 18.1596 14.9003C18.4896 15.1503 18.5496 15.6203 18.2896 15.9503C18.1496 16.1403 17.9296 16.2403 17.7096 16.2403Z",
    fill: "url(#paint2_linear_1721_53238)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1002 19.9005C14.9402 19.9005 14.7802 19.8505 14.6402 19.7405C13.3402 18.7305 11.6502 18.7305 10.3502 19.7405C10.0202 19.9905 9.55017 19.9305 9.30017 19.6105C9.05017 19.2805 9.11017 18.8105 9.43017 18.5605C11.2902 17.1205 13.6902 17.1205 15.5502 18.5605C15.8802 18.8105 15.9402 19.2805 15.6802 19.6105C15.5502 19.7905 15.3302 19.9005 15.1002 19.9005Z",
    fill: "url(#paint3_linear_1721_53238)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1721_53238",
    x1: 12.4936,
    y1: 8.58789,
    x2: 12.4936,
    y2: 12.5904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1721_53238",
    x1: 12.5,
    y1: 4.08789,
    x2: 12.5,
    y2: 9.11039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1721_53238",
    x1: 12.4982,
    y1: 12.9053,
    x2: 12.4982,
    y2: 16.2403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1721_53238",
    x1: 12.4938,
    y1: 17.4805,
    x2: 12.4938,
    y2: 19.9005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiActive);
export default __webpack_public_path__ + "static/media/wifi-active.243c95110da42b95873807e0328b6a35.svg";
export { ForwardRef as ReactComponent };